// extracted by mini-css-extract-plugin
export default {"accountHeader":"xm-z","newDesignAccountHeader":"ym-z","primeBadge":"zm-z","logout":"Am-z"};